<template>
    <!-- Header -->
    <div class="header tw:flex tw:items-center tw:justify-between tw:px-4"
        :class="sidebarCollapsed ? 'tw:left-24!' : 'tw:left-74!'">
        <div class="tw:flex tw:items-center">
            <!-- <router-link to="/admin/dashboard" class="logo logo-small">
                <img :src="config.image" alt="Logo" width="30" height="30" class="tw:rounded">
            </router-link> -->
            <a href="javascript:void(0);" id="toggle_btn" @click="enabledMenu"
                class="tw:ml-3 tw:text-gray-600 tw:hover:text-gray-900">
                <i class="fas fa-align-left"></i>
            </a>
            <a class="mobile_btn tw:ml-3 tw:text-gray-600" id="mobile_btn" href="javascript:void(0);">
                <i class="fas fa-align-left"></i>
            </a>
        </div>

        <ul class="tw-nav user-menu tw:flex tw:items-center tw:gap-3 tw:mb-0">
            <!-- Currency Exchange -->
            <li class="tw:flex tw:items-center">
                <span id="currencyExchange"
                    class="tw:bg-gray-100 tw:text-gray-700 tw:text-xs tw:font-medium tw:px-2.5 tw:py-1 tw:rounded-full">
                    USD ${{ config.usd }}
                </span>
            </li>

            <!-- Academia Button -->
            <li v-if="!(config.name || '').includes('Aliht')" class="tw:list-none">
                <a :href="getUrl('academia')" target="_blank"
                    class="tw-btn tw-btn-primary tw-btn-sm tw:flex tw:items-center tw:gap-1.5">
                    Academia
                </a>
            </li>

            <!-- Notifications -->
            <li class="nav-item dropdown noti-dropdown" v-click-outside="() => notiDropdownOpen = false">
                <a href="#" class="tw-dropdown-toggle nav-link tw:relative tw:flex tw:items-center tw:p-2"
                    @click.prevent="notiDropdownOpen = !notiDropdownOpen">
                    <i class="far fa-bell tw:text-lg tw:text-gray-600"></i>
                    <span
                        class="tw-badge tw-badge-pill tw:absolute tw:top-1 tw:right-1 tw:w-3 tw:h-3 tw:bg-red-500 tw:rounded-full"
                        v-if="totalNotification > 0"></span>
                </a>
                <div class="tw-dropdown-menu notifications tw:shadow-lg tw:rounded-lg tw:border tw:p-0"
                    data-vue-dropdown :class="{ show: notiDropdownOpen }">
                    <div
                        class="topnav-dropdown-header tw:bg-gray-50 tw:px-4 tw:py-3 tw:border-b tw:flex tw:items-center tw:justify-between">
                        <span class="notification-title tw:font-semibold tw:text-sm tw:text-gray-700">Notificaciones (
                            {{ totalNotification }} )</span>
                        <a v-if="totalNotification > 0"
                            class="clear-noti tw:text-xs tw:text-blue-600 tw:hover:underline"
                            @click="clearAllNotifications()"> Limpiar todo </a>
                    </div>
                    <div class="noti-content tw:max-h-80 tw:overflow-y-auto">
                        <ul class="notification-list tw:divide-y tw:mb-0 tw:pl-0">
                            <li class="notification-message tw:p-3 tw:hover:bg-gray-50 tw:transition-colors"
                                v-for="item in notifications" :key="'noti' + item.id" @click="getNotifications()">
                                <router-link :to="`${item.data.url}?notification=${item.id}`" class="tw:block">
                                    <div class="media tw:flex tw:items-start tw:gap-3">
                                        <span class="tw:flex-shrink-0">
                                            <img class="tw:rounded-full tw:w-8 tw:h-8 tw:object-cover" alt=""
                                                :src="item.data.icon">
                                        </span>
                                        <div class="media-body tw:flex-1">
                                            <p class="noti-details tw:text-sm tw:text-gray-800 tw:mb-1">
                                                <span class="noti-title tw:font-medium"> {{ item.data.title }} </span>
                                            </p>
                                            <p class="noti-time tw:text-xs tw:text-gray-400 tw:mb-0">
                                                <span class="notification-time"> {{ item.data.date | date_format_time }}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="topnav-dropdown-footer tw:bg-gray-50 tw:px-4 tw:py-2 tw:border-t tw:text-center">
                        <a class="clear-noti tw:text-xs tw:text-gray-600 tw:hover:text-gray-900"
                            @click="getNotifications()">Actualizar</a>
                    </div>
                </div>
            </li>
            <!-- /Notifications -->

            <!-- User Menu -->
            <li class="nav-item dropdown" v-click-outside="() => userDropdownOpen = false">
                <a href="javascript:void(0)"
                    class="tw-dropdown-toggle user-link nav-link tw:flex tw:items-center tw:p-1"
                    @click="userDropdownOpen = !userDropdownOpen">
                    <span class="user-img">
                        <img class="tw:rounded-full tw:w-9 tw:h-9 tw:object-cover" src="@/assets/img/user.jpg"
                            alt="Admin">
                    </span>
                </a>
                <div class="tw-dropdown-menu tw:shadow-lg tw:rounded-lg tw:border tw:py-1" data-vue-dropdown
                    :class="{ show: userDropdownOpen }">
                    <router-link class="tw-dropdown-item tw:px-4 tw:py-2 tw:text-sm tw:hover:bg-gray-100"
                        to="/admin/perfil">Perfil</router-link>
                    <router-link v-if="ACCESS_MENU_ACTION(AGENCY_CONFIGURATIONS_INDEX) && config.agency_owner"
                        class="tw-dropdown-item tw:px-4 tw:py-2 tw:text-sm tw:hover:bg-gray-100"
                        to="/admin/configuracion">Configuración</router-link>
                    <a v-if="config.agency_owner"
                        class="tw-dropdown-item tw:px-4 tw:py-2 tw:text-sm tw:hover:bg-gray-100"
                        :href="getUrl('contratos')" target="_blank">Contratos</a>
                    <div class="tw:border-t tw:border-gray-200 tw:my-1"></div>
                    <a class="tw-dropdown-item tw:px-4 tw:py-2 tw:text-sm tw:text-red-600 tw:hover:bg-red-50"
                        href="javascript:;" @click="logout()">Cerrar sesión</a>
                </div>
            </li>
            <!-- /User Menu -->
        </ul>
    </div>
    <!-- /Header -->
</template>

<script>
import { mapActions } from "vuex";
import { ROUTE_LOGIN } from "@/enums/RouteNameEnums";
import { ACCESS_MENU_ACTION } from '@/validations/auth/AccessControlList'
import { AGENCY_CONFIGURATIONS_INDEX } from '@/enums/MenuActionEnums';
import { toggleSidebar, isSidebarEffectivelyCollapsed } from '@/plugins/sidebarStore';
export default {
    name: 'TopBar',
    data() {
        return {
            config: {},
            notifications: [],
            totalNotification: 0,
            AGENCY_CONFIGURATIONS_INDEX,
            notiDropdownOpen: false,
            userDropdownOpen: false,
        }
    },
    computed: {
        sidebarCollapsed() {
            return isSidebarEffectivelyCollapsed();
        }
    },
    created() {
        this.getNotifications();

        window.Push.Permission.request();
        window.Echo.private(`App.Models.User.${localStorage.getItem("userNumber")}`)
            .notification((notification) => {
                if (notification.icon) {
                    window.Push.create(notification.title, {
                        body: notification.body,
                        link: notification.url,
                        icon: notification.icon,
                        onClick: function () {
                            window.location.href = notification.url;
                            this.close();
                        }
                    });
                }
                this.getNotifications();
            });
    },
    mounted() {
        setTimeout(() => {
            const config = JSON.parse(localStorage.getItem('configuration'));
            if (config !== undefined && config !== null) {
                this.config = config;
            }
        }, 2000);
    },
    methods: {
        ACCESS_MENU_ACTION,
        ...mapActions("auth", ["sendLogoutRequest"]),
        logout() {
            this.sendLogoutRequest();
            setTimeout(() => {
                this.$router.push({ name: ROUTE_LOGIN });
            }, 1500);
        },
        getNotifications() {
            fetch(`${this.$baseUrl}/api/${this.$subdomain}/notifications`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("authToken")}`
                },
            })
                .then(response => response.json())
                .then(data => {
                    this.notifications = data.data;
                    this.totalNotification = data.count;
                })
                .catch(error => {
                    console.error('Error en la fetch:', error);
                });
        },
        enabledMenu() {
            toggleSidebar();
        },
        clearAllNotifications() {
            this.$axios
                .post(`/${this.$subdomain}/notifications-clear-all`, {
                    '_method': 'PUT'
                })
                .then(response => {
                    this.getNotifications();
                })
                .catch((e) => {
                    this.$store.commit("setErrors", e);
                });
        },
        getUrl(service) {
            let token = localStorage.getItem("authToken");
            let hostname = location.hostname;
            let domain = hostname;
            let subdomain = "";

            if (hostname.includes(".")) {
                subdomain = hostname.split(".")[0];
                domain = hostname.split(".").slice(1).join(".");
            }

            return `http://www.${service}.${domain}?token=${token}&subdomain=${subdomain}`;
        }
    }
}
</script>

<style>
.clear-noti {
    cursor: pointer;
}
</style>